
'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  config = require('../../js/config'),
  utilities = require('../../js/utilities'),
  mediator = require('mediatorjs'),
  Router = require('./OfficesRouter'),
  OfficeRegionView = require('./OfficeRegionView'),
  Backbone = require('backbone'),
  filterParams = {}
  ;

import Analytics from  '../Analytics/Analytics';

Backbone.$ = $;

var OfficesView = Backbone.View.extend({

  events: {
    'change #regionSelector': 'onRegionChange',
    'change #divisionSelector': 'onDivisionChange'
  },

  initialize: function() {

    _.bindAll(this, 'onShowRegion', 'onHideRegion', 'onRegionChange', 'onDivisionChange');

    var self = this;
    this.OfficeRegions = [];

    var pageUrl = window.location.href;

    if (pageUrl.indexOf('?region=', 0) > -1) {
      window.document.getElementById('regionSelector').focus();
    }

    if (this.$el.length) {

      var OfficeRegion = this.$('.js-officeRegion'),
        searchParams = Modernizr.history ? document.location.search : document.location.hash.replace(/^([^?]+)/, '');

      _.each(OfficeRegion, function(element) {
        self.OfficeRegions.push(new OfficeRegionView({
          el: element
        }));
      });

      mediator.on(config.events.offices.showRegion, this.onShowRegion);
      mediator.on(config.events.offices.hideRegion, this.onHideRegion);

      if (Backbone.history && !Backbone.History.started) {
        Backbone.history.start({ pushState: Modernizr.history, silent: true });
      }

      if (searchParams.length) {

        filterParams = utilities.deserialize(searchParams);

        if (filterParams.country && filterParams.country.length) {
          this.showRegionById();
        }
        if (filterParams.division && filterParams.division.length) {
          this.switchDivision();
        }
      }
    }
  },

  /**
   * Hide all regions and fade the headers as another will be shown
   */
  onShowRegion: function(countryId) {
    _.each(this.OfficeRegions, function(region) {
      region.hide();
      region.fade();
    });
    filterParams.country = countryId;
    Router.userTrigger($.param(filterParams));
  },

  onHideRegion: function() {
    _.each(this.OfficeRegions, function(region) {
      region.unfade();
    });
  },

  /**
   * Page refresh with new region parameter
   */
  onRegionChange: function(e) {
    let analyticsRegionData = {
      event: config.analytics.events.click,
      category: config.analytics.categoryTypes.Support,
      action: config.analytics.actions.FindAnOffice,
      label: config.analytics.labelTypes.Region + ' - ' + e.target.value
    };
    Analytics.pushToEventFramework(analyticsRegionData);
    document.getElementById('regionSelector').focus();
    e.preventDefault();
    window.location.href = '?region=' + e.currentTarget.value;
  },

  /**
   * Hide all unrelated divisions based on matching data attribute.
   */
  onDivisionChange: function(e) {
    let analyticsDivisionData = {
      event: config.analytics.events.click,
      category: config.analytics.categoryTypes.Support,
      action: config.analytics.actions.FindAnOffice,
      label: config.analytics.labelTypes.Division + ' - ' + e.target.value
    };
    Analytics.pushToEventFramework(analyticsDivisionData);
    filterParams.division = e.currentTarget.value.toLowerCase();
    this.switchDivision();
    Router.userTrigger($.param(filterParams));
  },

  /**
   * Show region by matched dom data attribute from url param
   */
  showRegionById: function() {
    if (filterParams.country.length) {
      _.each(this.OfficeRegions, function(region) {
        if (region.countryId === filterParams.country) {
          region.show();
          return;
        }
      });
    }
  },
  switchDivision: function() {
    if (filterParams.division === 'all') {
      _.each(this.OfficeRegions, function(region) {
        region.showAllOffices();
      });
      return;
    }
    _.each(this.OfficeRegions, function(region) {
      region.filterOfficesOnDivision(filterParams.division);
    });
  }

});

module.exports = OfficesView;



// WEBPACK FOOTER //
// ./assets/components/Offices/OfficesView.js